import { createUrl } from 'app/utils';
import { Button, Checkbox, Flex, Hr, Label, Select, Typography } from 'components';
import { ProductTypeEnum } from 'features/products';
import { useResources } from 'features/resources';
import useSearch from 'features/search/useSearch';
import { ChangeEvent, useCallback, useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
// import styled from 'styled-components';

// const BtnClearFilters = styled.button``;

const ResultsSidebar = () => {
  const [enrolled, setEnrolled] = useState<boolean | null>(null);
  const [productTypes, setProductTypes] = useState<number[]>([]);

  const navigate = useNavigate();

  const { fetchSearch, searchText, limitPerPage } = useSearch();
  const {
    usingReports,
    usingExams,
    schools: { schoolB3 },
  } = useResources();

  const [searchParams] = useSearchParams();
  const searchProductsTypes = searchParams.get('types');
  const searchEnrolled = searchParams.get('enrolled');

  const px = 3;

  const changeProducts = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      if (e.target.checked) {
        setProductTypes([...productTypes, +e.target.value]);
      } else {
        setProductTypes(productTypes.filter((p) => p !== +e.target.value));
      }
    },
    [productTypes]
  );

  const refetchSearch = useCallback(() => {
    navigate(
      `${createUrl('search')}?q=${searchText}&limit=${limitPerPage}&page=${1}${productTypes?.length ? `&types=${productTypes.join(',')}` : ''}${
        enrolled !== null ? `&enrolled=${Number(enrolled)}` : ''
      }`
    );

    fetchSearch({ searchText, limit: limitPerPage, productTypes, enrolled });
  }, [searchText, limitPerPage, productTypes, enrolled]);

  const clearFilters = () => {
    setProductTypes([]);
    setEnrolled(null);

    fetchSearch({ searchText, limit: limitPerPage });
    navigate(`${createUrl('search')}?q=${searchText}&limit=${limitPerPage}&page=1`);
  };

  const filters = [
    { id: ProductTypeEnum.Course, label: 'Cursos' },
    { id: ProductTypeEnum.Program, label: 'Programas' },
    { id: ProductTypeEnum.Journey, label: 'Jornadas' },
    { id: ProductTypeEnum.MasterClass, label: 'MasterClass' },
    { id: ProductTypeEnum.LiveMeeting, label: 'Lives' },
    ...(usingReports ? [{ id: ProductTypeEnum.AnalysisReport, label: 'Relatórios' }] : []),
    ...(usingExams ? [{ id: ProductTypeEnum.PracticeExam, label: 'Avaliações' }] : []),
  ];

  useEffect(() => {
    if (searchProductsTypes) setProductTypes(searchProductsTypes.split(',').map((i) => +i));
    if (searchEnrolled) setEnrolled(+searchEnrolled === 1);
  }, []);

  return (
    <Flex flexDirection="column" py={{ m: 4, d: 5 }} width={{ d: 270 }} mr={{ d: 40 }} flexShrink={0} flexGrow={0}>
      <Flex flexGrow={0} px={px} alignItems="center" justifyContent="space-between">
        <Typography as="span" type="type1" color="gray_600" fontWeight="bold" upper>
          Filtros
        </Typography>

        <Typography
          onClick={clearFilters}
          as="span"
          type="type0"
          color={schoolB3 ? 'dark_150' : 'primary_400'}
          upper
          style={{ cursor: 'pointer', textDecoration: 'underline' }}
        >
          Limpar
        </Typography>
      </Flex>

      <Hr mb={4} />

      <Flex flexGrow={0} px={px} flexDirection="column">
        <Select
          onChange={(e) => {
            setEnrolled(e.target.value === 'all' ? null : +e.target.value === 1);
          }}
          value={enrolled === null ? '' : Number(enrolled)}
          arrowColor={schoolB3 ? 'dark_150' : undefined}
        >
          <option value="all">Todos</option>
          <option value={1}>Matriculado</option>
          <option value={0}>Não matriculado</option>
        </Select>
      </Flex>

      <Flex flexGrow={0} px={px} mt={4} flexDirection="column">
        <Flex flexGrow={0} flexDirection="column" style={{ gap: 5 }}>
          {filters.map((item) => (
            <Label key={`filter-${item.id}`}>
              <Flex alignItems="center" justifyContent="space-between" flexGrow={0}>
                <Typography type="type1" color={schoolB3 ? 'black80' : 'dark_350_70'}>
                  {item.label}
                </Typography>

                <Checkbox
                  value={item.id}
                  checked={productTypes.includes(item.id)}
                  color="black30"
                  colorActive={schoolB3 ? 'dark_150' : undefined}
                  onChange={changeProducts}
                />
              </Flex>
            </Label>
          ))}
        </Flex>
      </Flex>

      <Flex flexGrow={0} px={px} pt={4} flexDirection="column">
        <Button onClick={refetchSearch} outline={schoolB3 ? false : true}>
          Atualizar
        </Button>
      </Flex>
    </Flex>
  );
};

export default ResultsSidebar;
